import { useTranslation } from "react-i18next";
import { NewMaterialForm } from "../../../components";
import PageHeader from "../../../components/carbon/PageHeader/PageHeader";

const CreateBuyerMaterial = () => {
  const { t } = useTranslation();
  return (
    <div>
      <PageHeader title={t("materials.add")} />
      <NewMaterialForm />
    </div>
  );
};

export default CreateBuyerMaterial;
